import React, { useEffect, useState } from 'react';
//*MUI
import { Box, Modal, Tooltip} from '@mui/material';
//*files
import cssClasses from "./SelectParkingModal.module.css"
import Button from '../../../../Subcomponents/Button';
import Close from '../../../../Components/Icons/Close';
import { errorTost, successTost } from '../../../../Services/Toast';
import DropDown from '../../../../Subcomponents/DropDown';
import { deleteOldParkingRecords, fetchSelectedParkingNumbers, getParkingNumbersFromParkingInventory, getParkingTypes, insertCRMLogs, insertParkingDetails, updateParkingSelectionFlag, updateParkingStatusFlag } from '../../../../Services/AllAllotments';
import { dismissLoader, presentLoader } from '../../../../Services/loader';
import { groupBy, orderBy, uniqBy, sortBy, chain } from 'lodash';
import ConfirmationAlert from '../../../../Subcomponents/ConfirmationAlert';
import { useSelector } from 'react-redux';
import { supabase } from "../../../../supabaseClient";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: 'fit-Content',
  // height : '80%',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function SelectParkingModal({ open, handleClose, allotment, getCrmAllotmentsFromServer }) {
 
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [selectedParkingNos, setSelectedParkingNos] = useState([]);
  //Storing parking types after finding unique and latest one
  const [uniqueParkingTypes, setUniqueParkingTypesobj] = useState([]);
  //Parking types to display in dropdown
  const [parkingTypes, setParkingTypes] = useState([]);
  //selected parking type from dropdown
  const [selectedType, setSelectedType] = useState("");
  //parking data by floors
  const [parkingDataByFloors, seParkingDataByFloors] = useState([]); 
  //store previously saved parking
  const [savedUserParking, setSavedUserParking] = useState([]);
  const [submitParkingSelectionModalToggle, setSubmitParkingSelectionModalToggle] = useState(false);
  const [isParkingSelected, setIsParkingSelected] = useState(false);


  useEffect(()=>{
		let insertParkingListener = supabase
      .from("ParkingSelection")
			.on("INSERT", (payload) => {
				console.log("Insert Listener", payload);
        getParkingNumbers(selectedType);
        getSelectedParkingNumbers();
			})
      .on("DELETE", (payload) => {
				console.log("Delete Listener", payload);
        getParkingNumbers(selectedType);
        getSelectedParkingNumbers();
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});

		return () => {
			if (insertParkingListener) {
				supabase.removeSubscription(insertParkingListener);
				insertParkingListener = null;
			}
		};
	}, [savedUserParking, selectedParkingNos, parkingDataByFloors])


  useEffect(() => {
    getParkingTypesForProject();
    getSelectedParkingNumbers();
  }, [])

  const handleButtonClick = (selectedParking) => {
    const isSelected = selectedParkingNos.some(
      (selected) => (selected.parkingInventoryId === selectedParking.parkingInventoryId));

    if (isSelected) {
      const updatedSelectedParkingNos = selectedParkingNos.filter(
        (selected) => (selected.parkingInventoryId !== selectedParking.parkingInventoryId));
      setSelectedParkingNos(updatedSelectedParkingNos);
    } else { 
      if (selectedParkingNos.length < 4) {
        setSelectedParkingNos([...selectedParkingNos, selectedParking]);
      }
    }
  };
  
  //step 1.Setting Parking Types in dropdown for the project
  function getParkingTypesForProject(){
    getParkingTypes(allotment?.project_id).then((res) => {
      if(res?.data.length > 0){
         // const sortedData = orderBy(res?.data, [obj => obj.parkingTypeId.created_at], ['desc']);
        const sortedData = orderBy(res?.data, [obj => obj?.parkingTypeId?.parkingType, obj => obj?.parkingTypeId?.created_at], ['asc', 'desc']);
        const uniqueParkingTypes = uniqBy(sortedData, obj => obj?.parkingTypeId?.parkingType);
        // console.log("uniqueParkingTypesObj", uniqueParkingTypes);
        setUniqueParkingTypesobj(uniqueParkingTypes);
        const parkingTypeArray = uniqueParkingTypes.map(obj => obj?.parkingTypeId.parkingType);
        // console.log("Parking Types", parkingTypeArray);
        setParkingTypes(parkingTypeArray);
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  //Getting Parking type id from selected parking type
  function getSelectedParkingTypeId(data, selectedParkingType){
    const parkingObj = data.find(obj => obj.parkingTypeId.parkingType === selectedParkingType);
    // console.log("parkingObj", parkingObj)
    return parkingObj ? parkingObj?.parkingTypeId?.parkingTypeId : null;
  }


  function getParkingNumbers(selectedParkingType){
    // console.log("selectedParkingType", selectedParkingType);
    const parkingTypeId = getSelectedParkingTypeId(uniqueParkingTypes, selectedParkingType);
    // console.log("parkingTypeId", parkingTypeId);

    if(parkingTypeId) {
      getParkingNumbersFromParkingInventory(allotment?.project_id, parkingTypeId).then((res) => {
        // console.log("Parking Numbers", res);

        const sortedData = orderBy(res.data, [(item) => parseInt(item.parkingNumber), 'created_at'], ['asc', 'desc']);
        const uniqueParkingNumbers = uniqBy(sortedData, 'parkingNumber'); 
        // console.log("uniqueParkingNumbers", uniqueParkingNumbers);

        const newParkingArray = uniqueParkingNumbers.map(parking => ({
          floorNumber: parking?.floorNumber,
          parkingInventoryId: parking.parkingInventoryId,
          parkingNumber: parking.parkingNumber,
          parkingStatusId: parking.parkingStatusId,
          parkingTypeId: parking.parkingTypeId.parkingTypeId,
          parkingType: parking.parkingTypeId.parkingType,
          parkingLength : parking?.parkingLength,
          parkingBreadth : parking?.parkingBreadth,
          parkingHeight : parking?.parkingHeight,
          parkingArea : parking?.parkingLength * parking?.parkingBreadth * parking?.parkingHeight,
          version: parking.version
      }));

        const dataByFloors = groupBy(newParkingArray, "floorNumber");
        console.log("ParkingDataByFloors", dataByFloors);
        
        seParkingDataByFloors(dataByFloors);
        
        
      }).catch((err) => {
        console.log(err);
      })
    }
    
  }


  function getSelectedParkingNumbers(){
    // const parkingTypeId = getSelectedParkingTypeId(uniqueParkingTypes, selectedParkingType);
    // console.log("parkingTypeId", parkingTypeId);

    // if(parkingTypeId){
      fetchSelectedParkingNumbers(allotment?.allotment_payment_id).then((res) => {
        // console.log("user selected parking", res);
        // setSavedUserParking(res?.data);
        const newParkingArray = res?.data.map(parking => ({
          floorNumber: parking.parkingInventoryId.floorNumber,
          parkingInventoryId: parking.parkingInventoryId.parkingInventoryId,
          parkingNumber: parking.parkingInventoryId.parkingNumber,
          parkingStatusId: parking.parkingInventoryId.parkingStatusId,
          parkingTypeId: parking.parkingInventoryId.parkingTypeId.parkingTypeId,
          parkingType: parking.parkingInventoryId.parkingTypeId.parkingType,
          version: parking.parkingInventoryId.version
      }));
      // console.log("newParkingArray", newParkingArray);
      const sortedParkingArray = chain(newParkingArray)
          .sortBy([(parking) => parseInt(parking.floorNumber), (parking) => parseInt(parking.parkingNumber)])
          .value();      
        console.log("sortedParkingArray", sortedParkingArray);
      setSelectedParkingNos(sortedParkingArray);
      setSavedUserParking(sortedParkingArray);
      }).catch((err) => {   
        console.log(err);
      })
    // }
  }

  // console.log("Saved User", savedUserParking);

  async function updateParkingFlags(){
    dismissLoader();
      await updateParkingSelectionFlag(allotment?.id).then((res)=>{
        console.log(res);
        if(isParkingSelected){
          const crmObj = {
            message : `${createdSavedParkingString(selectedParkingNos)} is selected by ${loggedInUser?.name} for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name}.`,
            allotmentPaymentId : allotment?.allotment_payment_id,
            crmStatus : "Parking selected"
            }
            addCRMLogs(crmObj);
            closeModal();
        }else{
          //skipped parking selection
          const crmObj = {
            message : `Parking is not selected for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name} by ${loggedInUser?.name}`,
            allotmentPaymentId : allotment?.allotment_payment_id,
            crmStatus : "Parking not selected"
            }
            addCRMLogs(crmObj);
            closeModal();
        }
      }).catch((err) => {
        console.log(err);
        dismissLoader();
        errorTost(err);
        setSubmitParkingSelectionModalToggle(false);
        handleClose();
      })
  }

  function closeModal(){
    dismissLoader();
    successTost("Parking details submitted successfully!");
    setSubmitParkingSelectionModalToggle(false);
    getCrmAllotmentsFromServer(false);
    handleClose();
  }

  async function deleteParkingRecords(deleteFlag = false){
    const totalRecords = savedUserParking.length;
    let deleteCount = 0;
    for(const savedParking of savedUserParking){
      const foundIndex = selectedParkingNos.findIndex(parking => parking.parkingInventoryId === savedParking.parkingInventoryId);
      if (foundIndex === -1) {
          deleteOldParkingRecords(savedParking?.parkingInventoryId)
          .then((res) => {
              console.log("Deleted", res);
              if(!res?.error){
                updateParkingStatusFlag(savedParking?.parkingInventoryId, 0).then((res) => {
                  console.log("Updated Deleted Flag", res);
                  deleteCount++
                  if(deleteCount === totalRecords && deleteFlag){
                    successTost("Parking details submitted successfully!");
                    setSubmitParkingSelectionModalToggle(false);
                    getCrmAllotmentsFromServer(false);
                    handleClose();
                  }
                }).catch((err)=>{
                  console.log("Status", err);
                })      
              }else{
                console.log(res?.error);
                errorTost(res?.error);
              }           
          })
          .catch((err) => {
              console.log(err);
              setSubmitParkingSelectionModalToggle(false);
              errorTost(err);
          });
      }
    }
  }

  function createdSavedParkingString(array){
    let str = "";
    for(const selectedParking of array){
      str += `Parking No ${selectedParking?.parkingNumber} ${selectedParking?.parkingType} Floor ${selectedParking?.floorNumber}, `
    }
    return str;
  }


  async function saveParkingDetails(){
    const allotmentPaymentId = allotment?.allotment_payment_id;
    const totalRecords = selectedParkingNos.length;
    let successCount = 0;
    let insertCount = 0;
    presentLoader();

    for(const parking of selectedParkingNos){
      const foundIndex = savedUserParking.findIndex(savedParking => savedParking.parkingInventoryId === parking.parkingInventoryId);
        if (foundIndex !== -1) {
            // If record is present in both savedUserParking and selectedParkingNos
            successCount++;
            if (successCount === totalRecords) {
              if(allotment?.crm_status_id === 5){
                const crmObj = {
                  message : `${createdSavedParkingString(savedUserParking)} for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name} is changed to
                              ${createdSavedParkingString(selectedParkingNos)} by ${loggedInUser?.name}`,
                  allotmentPaymentId : allotment?.allotment_payment_id,
                  crmStatus : "Parking selection changed"
                  }
                  addCRMLogs(crmObj);
                  closeModal();
              }else{
                updateParkingFlags();
              }
            }
            } else {
            // If record present in selected and not present in saved, then insert
            const obj = {
                allotmentPaymentId: allotmentPaymentId,
                parkingInventoryId: parking.parkingInventoryId,
                version: parking.version,
                parkingTypeId: parking.parkingTypeId,
            };
            
            await insertParkingDetails(obj).then(async (res) => {
              console.log(res);
              if(!res?.error){
                successCount++;
                insertCount++;
                //update status in Parking Inventory
                await updateParkingStatusFlag(parking?.parkingInventoryId, 1).then((res) => {
                  console.log("Updated Parking Sttaus Id", res);
                    if (successCount === totalRecords) {
                      if(allotment?.crm_status_id === 5){
                        let crmObj;
                        if(insertCount === successCount && savedUserParking?.length === 0){
                          crmObj = {
                            message : `Selected Parking ${createdSavedParkingString(selectedParkingNos)} for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name} is selected by ${loggedInUser?.name}`,
                            allotmentPaymentId : allotment?.allotment_payment_id,
                            crmStatus : "Parking Selected"
                            }
                        }else {
                          crmObj = {
                            message :  `Selected Parking ${createdSavedParkingString(savedUserParking)} for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name} is changed to
                                       ${createdSavedParkingString(selectedParkingNos)} by ${loggedInUser?.name}`,
                            allotmentPaymentId : allotment?.allotment_payment_id,
                            crmStatus : "Parking selection changed"
                            }
                        }
                          addCRMLogs(crmObj);  
                          closeModal();
                      }else{
                        updateParkingFlags();
                      }
                    }
                }).catch((err)=>{
                  console.log("Status", err);
                })   
              }else{
                console.log(res?.error);
              }                    
            }).catch((err) => {
              console.log(err);
              dismissLoader();
              errorTost(err);
              setSubmitParkingSelectionModalToggle(false);
              handleClose();
            });
            }
    }
  // Delete records from savedUserParking that are not present in selectedParkingNos
    if(savedUserParking?.length > 0){
      deleteParkingRecords();
    }
  }

 async function addCRMLogs(crmObj){
    await insertCRMLogs(crmObj).then((res) => {
      console.log("Logs saved", res);
    }).catch((err) => {
      console.log(err);
      setSubmitParkingSelectionModalToggle(false);
      handleClose();
      errorTost(err);
    })
  }

	function submitParkingSelection(){
		presentLoader();
		if(allotment?.id){
      //If user has selected parking
       if(isParkingSelected === true){
          saveParkingDetails();
       }else{
        //If user has skipped parking selection
        if(allotment?.crm_status_id === 5){
          const crmObj = {
            message : `Parking is not selected for allotment unit ${allotment?.unit_no} of project ${allotment?.project_name} by ${loggedInUser?.name}`,
            allotmentPaymentId : allotment?.allotment_payment_id,
            crmStatus : "Parking not selected"
            }
            addCRMLogs(crmObj);
          closeModal();
        }else{
          updateParkingFlags();
        }       
      }
		}
	}
  
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Parking</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box padding={"3rem"} backgroundColor={"#F9FAFB"}>
                <div className={cssClasses.middleDiv}>
                  <Box width={'100%'} className={cssClasses.gridContainer}>
                    <div className={cssClasses.leadDetails}>
                      <p>Customer Name:</p>
                      <div>{allotment?.lead_name}</div>
                    </div>
                    <div className={cssClasses.leadDetails}>
                      <p>Unit:</p>
                      <div>
                        {!allotment?.inventory_merge_id && (
                          <span>
                            {" "}
                            {allotment?.displaywingname ? allotment?.displaywingname : allotment?.wing_name} - {allotment?.unit_no}{" "}
                          </span>
                        )}
                        {allotment?.inventory_merge_id && (
                          <span>
                            {" "}
                            {/* {allotment?.merged_wing_name} -{" "} */}
                            {allotment?.mergeddisplaywingname ? allotment?.mergeddisplaywingname : allotment?.merged_wing_name} -{" "}
                            {allotment?.merged_unit_no_one} {"-"} {allotment?.merged_unit_no_two}{" "}
                          </span>
                        )}
                        <span>|</span>
                        {!allotment?.inventory_merge_id && <span>{allotment?.project_name}</span>}
                        {allotment?.inventory_merge_id && <span>{allotment?.merged_project_name}</span>}
						          </div>
                    </div>
                  </Box>
                  <Box style={{width : "60%"}}>
                    <Box className={cssClasses.InputTitle}>
                      Parking Type <sup style={{ color: "red", fontSize: "1.2rem" }}>*</sup>
                    </Box>
                    <DropDown
                      placeHolder={"Select"}
                      list={parkingTypes}
                      selectedValue={selectedType}
                      onChangeSelect={(value) => {
                        setSelectedType(value);
                        getParkingNumbers(value);
                      }}
                      style={{
                        background: "#F2F4F7",
                        selectedColor: "#667085",
                      }}
                    />
                  </Box>
                </div>
                {selectedType && <div>
                    <div className={cssClasses.displayDiv}>
                      {/* <div style={{fontSize : "14px", fontWeight : "500", color : "#344054"}}>Select Parking</div> */}
                      <div className={cssClasses.infoDiv}>
                        <div className={cssClasses.paddingLimit}><sup>*</sup>Limit : 4 Parking</div>
                        <div className={cssClasses.wrapperBox}>
                          <div className={cssClasses.available}></div>
                          <div className={cssClasses.parkingStatus}>Available</div>
                        </div>
                        <div className={cssClasses.wrapperBox}>
                          <div className={cssClasses.selected}></div>
                          <div className={cssClasses.parkingStatus}>Selected</div>
                        </div>
                        <div className={cssClasses.wrapperBox}>
                          <div className={cssClasses.booked}></div>
                          <div className={cssClasses.parkingStatus}>Booked</div>
                        </div>
                      </div>
                    </div>
                    <div className={cssClasses.displayFloor}>
                      {/* Render parking spots */}
                      {parkingDataByFloors &&
                        Object.keys(parkingDataByFloors).length === 0 ? (
                          <div className='noParkingDiv'>No parking data available</div>
                        ) : (
                          Object.keys(parkingDataByFloors).map((floor) => {
                            return (
                              <div key={floor} className={cssClasses.floorDiv}>
                                <div style={{ fontSize: "12px", fontWeight: "500", color: "#344054" }}>
                                  Parking Floor - {floor}
                                </div>
                                {/* Display parking number in floor */}
                                <div className={cssClasses.displayParkingSlot}>
                                  {parkingDataByFloors[floor].map((parking) => {
                                    // Check if the parking slot is selected
                                    const isSelected = selectedParkingNos.some(
                                      (selectedParking) => (selectedParking?.parkingInventoryId === parking?.parkingInventoryId) 
                                    );
                                    const isDisabled = parking?.parkingStatusId === 1 && !savedUserParking.some(
                                      (savedParking) => savedParking?.parkingInventoryId === parking?.parkingInventoryId
                                    );
                                    return (
                                      <Tooltip
                                        // style={{top: "20px"}}
                                        placement="top-start"
                                        title={
                                          <div>
                                            <p style={{ fontSize: "1.4rem" }}>Length : {parking?.parkingLength} m</p>
                                            <p style={{ fontSize: "1.4rem" }}>Breadth : {parking?.parkingBreadth} m</p>
                                            <p style={{ fontSize: "1.4rem" }}>Height : {parking?.parkingHeight} m</p>
                                            <p style={{ fontSize: "1.4rem" }}>Area : {parking?.parkingArea} sq.m</p>
                                          </div>
                                        }
                                        >
                                         <button
                                          key={parking?.parkingInventoryId}
                                          className={`${cssClasses.parkingSlot} 
                                            ${isDisabled && cssClasses.allotedParkingSlot}
                                            ${isSelected ? cssClasses.selectedParkingSlot : ''}`}
                                          disabled={isDisabled}
                                          onClick={() => handleButtonClick(parking)}
                                        >
                                          {parking?.parkingNumber}
                                        </button>
                                      </Tooltip>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })
                        )}
                    </div>
                    
                </div>      
              }
              {selectedParkingNos.length > 0 &&
                     <div className={cssClasses.selectedParking}>
                      Selected Parking -   
                      {selectedParkingNos.map((selectedParking, index) =>  (
                            <span key={index}>
                                {`${selectedParking?.parkingNumber} - 
                                  ${selectedParking?.parkingType} 
                                  Floor(${selectedParking?.floorNumber}), `}
                            </span>
                          )
                      )}
                    </div>}
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    color: '#344054',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={allotment?.crm_status_id === 4 ? 'Skip' : 'Cancel'}
                  clicked={() => {
                    if(allotment?.crm_status_id === 4 ){ 
                      setIsParkingSelected(false);
                      setSubmitParkingSelectionModalToggle(true);
                    }else{
                      setSubmitParkingSelectionModalToggle(false);
                      handleClose();
                    }
                  }}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  // disable={selectedFloor === "" || selectedType === ""}
                  disable={savedUserParking?.length === 0 && selectedParkingNos?.length === 0}
                  btnName={'Save'}
                  clicked={()=> {
                    setIsParkingSelected(true);
                    setSubmitParkingSelectionModalToggle(true);
                  }}
                  // disable={selectedParkingNos.length === 0}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>

      {submitParkingSelectionModalToggle && 
				<ConfirmationAlert
					confirm={(e) => {
						if(e === "confirmed"){
              if(isParkingSelected && selectedParkingNos?.length === 0){
                deleteParkingRecords(true);
              }
							submitParkingSelection();
						}
					}}
					buttonTitle={"Cancel"}
					returnRespButton={"Continue"}
					close={() => {
						 setSubmitParkingSelectionModalToggle(false);
						 setIsParkingSelected(false);
					}}
					title={"Warning"}
					subTitle={ (isParkingSelected && selectedParkingNos?.length === 0) ? `Selected Parking will be removed for ${allotment?.lead_name}, do you want to proceed?` 
                : isParkingSelected ? `Parking is selected for ${allotment?.lead_name}, do you want to proceed?` 
								: `Parking is not selected for ${allotment?.lead_name}, do you want to proceed?`}
					open={submitParkingSelectionModalToggle}
       	/>
      }
    </>
  )
}

export default SelectParkingModal;